import {money} from "@/lib/inner";

export const DpPicker = ({total, min, value, onChange}) => {
  const floor = Math.min(min, total);
  const options = [...new Set([floor, Math.max(floor, Math.round(total / 2 / 1000) * 1000), total])];
  const invalid = !value || value < floor || value > total;
  return <div className="dp-picker" data-testid="dp-picker">
    <p className="field-label">Uang muka (DP) <span className="optional">Minimal {money(floor)}</span></p>
    <div className="dp-chips">{options.map(v => <button type="button" key={v} data-testid={`dp-chip-${v}`} className={value === v ? "on" : ""} onClick={() => onChange(v)}>{v === total ? `Lunas · ${money(v)}` : money(v)}</button>)}</div>
    <label>Nominal lain<input data-testid="dp-amount-input" type="number" min={floor} max={total} step="1000" value={value || ""} onChange={e => onChange(Number(e.target.value))}/></label>
    {invalid ? <p className="error" data-testid="dp-error">DP minimal {money(floor)} dan maksimal {money(total)}.</p> : <p className="muted">Sisa dibayar di outlet: <b data-testid="dp-remaining">{money(total - value)}</b></p>}
  </div>;
};
